import { useMemo } from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';

import { ThemeProvider, useTheme, getAntdTheme } from './theme';
import { useI18n } from './i18n';
import { antdLocales } from './i18n/antdLocales';

const LABEL_PLACEHOLDER = ['$', '{label}'].join('');

const AntdBridge = ({ children }) => {
  const { theme } = useTheme();
  const { language, t } = useI18n();

  const config = useMemo(() => getAntdTheme(theme, antdTheme), [theme]);
  const validateMessages = useMemo(
    () => ({
      required: t('validation.required', { field: LABEL_PLACEHOLDER }),
      types: { number: t('validation.number') },
    }),
    [t],
  );

  return (
    <ConfigProvider theme={config} locale={antdLocales[language]} form={{ validateMessages }}>
      {children}
    </ConfigProvider>
  );
};

export const AppProviders = ({ children }) => (
  <ThemeProvider>
    <AntdBridge>{children}</AntdBridge>
  </ThemeProvider>
);
